module.exports = __webpack_public_path__ + "img/arrow-down-left-square-fill.dec0fb44.svg";